<template>
    <fieldset>
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Miljö</div>
            </div>
            <select
                class="custom-select"
                required
                v-model="environment"
                @change="onUpdate"
            >
                <option value="production">Produktionsmiljö</option>
                <option value="playground">Testmiljö</option>
            </select>
        </div>
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Merchant Id</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="merchantId"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Secret</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="secret"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Partner Key</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="partnerKey"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Länk till era köpvilkor</div>
            </div>
            <input
                type="url"
                class="form-control"
                required
                v-model="termsUrl"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Leverans - Namn</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="fieldFullName"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">
                    Fältnamn: Leverans gatuadress 1
                </div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="fieldAddress1"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">
                    Fältnamn: Leverans gatuadress 2
                </div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="fieldAddress2"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Leverans Postnr</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="fieldZipCode"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Leverans Ort</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="fieldCity"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Faktura - Namn</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="fieldInvoiceFullName"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">
                    Fältnamn: Faktura gatuadress 1
                </div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="fieldInvoiceAddress1"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">
                    Fältnamn: Faktura gatuadress 2
                </div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="fieldInvoiceAddress2"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Faktura Postnr</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="fieldInvoiceZipCode"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Faktura Ort</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="fieldInvoiceCity"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: ID. nr</div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="fieldIdNumber"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: CheckoutOrderId</div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="fieldCheckoutOrderId"
                @input="onUpdate"
            />
        </div>
    </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const merchantId = ref(null);
const secret = ref(null);
const partnerKey = ref(null);
const termsUrl = ref(null);
const environment = ref(null);
const fieldFullName = ref(null);
const fieldAddress1 = ref(null);
const fieldAddress2 = ref(null);
const fieldZipCode = ref(null);
const fieldCity = ref(null);
const fieldInvoiceFullName = ref(null);
const fieldInvoiceAddress1 = ref(null);
const fieldInvoiceAddress2 = ref(null);
const fieldInvoiceZipCode = ref(null);
const fieldInvoiceCity = ref(null);
const fieldIdNumber = ref(null);
const fieldCheckoutOrderId = ref(null);
const serializedValue = computed(() => {
  return {
    merchant_id: merchantId.value,
    secret: secret.value,
    partner_key: partnerKey.value,
    terms_url: termsUrl.value,
    environment: environment.value,
    field_full_name: fieldFullName.value,
    field_address1: fieldAddress1.value,
    field_address2: fieldAddress2.value,
    field_zip_code: fieldZipCode.value,
    field_city: fieldCity.value,
    field_invoice_full_name: fieldInvoiceFullName.value,
    field_invoice_address1: fieldInvoiceAddress1.value,
    field_invoice_address2: fieldInvoiceAddress2.value,
    field_invoice_zip_code: fieldInvoiceZipCode.value,
    field_invoice_city: fieldInvoiceCity.value,
    field_id_number: fieldIdNumber.value,
    field_checkout_order_id: fieldCheckoutOrderId.value
  };
});
function onUpdate() {
    emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    merchantId.value = modelValue.value.merchant_id;
    secret.value = modelValue.value.secret;
    partnerKey.value = modelValue.value.partner_key;
    termsUrl.value = modelValue.value.terms_url;
    environment.value = modelValue.value.environment;
    fieldFullName.value = modelValue.value.field_full_name;
    fieldAddress1.value = modelValue.value.field_address1;
    fieldAddress2.value = modelValue.value.field_address2;
    fieldZipCode.value = modelValue.value.field_zip_code;
    fieldCity.value = modelValue.value.field_city;
    fieldInvoiceFullName.value = modelValue.value.field_invoice_full_name;
    fieldInvoiceAddress1.value = modelValue.value.field_invoice_address1;
    fieldInvoiceAddress2.value = modelValue.value.field_invoice_address2;
    fieldInvoiceZipCode.value = modelValue.value.field_invoice_zip_code;
    fieldInvoiceCity.value = modelValue.value.field_invoice_city;
    fieldIdNumber.value = modelValue.value.field_id_number;
    fieldCheckoutOrderId.value = modelValue.value.field_checkout_order_id;
    if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
      onUpdate();
    }
  }
}, {
  immediate: true
});
</script>
